export default "__VITE_ASSET__b11dd0b5__"